export default __webpack_public_path__ + "static/media/sparck-mountain-waves-teal.aaf158ef.png";